// extracted by mini-css-extract-plugin
export default {"warning-container":"styles_warning-container__p53lY","warning":"styles_warning__JNPYZ"};